import type { AgResourceLanguage } from 'shared/providers/TranslationProvider/locales/types';
import type { NotificationType } from 'shared/ui/Notification/Notification.types';

export type SubscriptionApiErrorCode = `${number}.SUB_API.${number}`;

export type SubscriptionApiErrorDetails = {
  type: NotificationType;
  translationKey: keyof AgResourceLanguage['subscriptionApiErrorMessages'];
};

export type SubscriptionApiErrorCodeDetails = Record<
  SubscriptionApiErrorCode,
  SubscriptionApiErrorDetails
>;

export const SUBSCRIPTION_API_ERRORS_DETAILS: SubscriptionApiErrorCodeDetails = {
  '8.SUB_API.6': {
    type: 'error',
    translationKey: 'currentBillingCycleStatusIsUnknown'
  },
  '8.SUB_API.11': {
    type: 'warning',
    translationKey: 'rebillInProgress'
  },
  '8.SUB_API.12': {
    type: 'warning',
    translationKey: 'paymentFailed'
  }
};
